import { HttpClient, HttpResponse } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { DwConfigService, DwConfigServiceToken } from "@devwareapps/devware-cap";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class PlanOfActionPdfService {
    private apiRoot: string;

    constructor(
        private http: HttpClient,
        @Inject(DwConfigServiceToken) configService: DwConfigService
    ) {
        this.apiRoot = configService.coreConfig.apiRoot;
    }

    downloadPlanOfActionPdf(planOfActionId: number, acsTestPortionIds?: number[]): Observable<void> {
        const url = `${this.apiRoot}/pilexos/plan-of-actions/${planOfActionId}/pdf`;
        const request = {
            AcsTestPortionIds: acsTestPortionIds || []
        };

        return this.http.post(url, request, { observe: 'response', responseType: 'blob' })
            .pipe(map(response => {
                this.downloadBlob(response);
            }));
    }

    private downloadBlob(response: HttpResponse<Blob>) {
        const fileName = this.getFileName(response) || 'PlanOfAction.pdf';
        const blob = response.body;

        if (!blob) {
            return;
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);
    }

    private getFileName(response: HttpResponse<Blob>): string {
        const disposition = response.headers.get('content-disposition');

        if (!disposition) {
            return null;
        }

        const fileNameMatch = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(disposition);
        const encodedName = fileNameMatch && (fileNameMatch[1] || fileNameMatch[2]);

        return encodedName ? decodeURIComponent(encodedName) : null;
    }
}
